import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { useProps } from "./auth-service-tools225.js";
import { factory } from "./auth-service-tools248.js";
import { InputBase } from "./auth-service-tools309.js";
const defaultProps = {};
const TextInput = factory((props, ref) => {
  const _props = useProps("TextInput", defaultProps, props);

  return /* @__PURE__ */jsxRuntimeExports.jsx(InputBase, {
    component: "input",
    ref,
    ..._props,
    __staticSelector: "TextInput"
  });
});
TextInput.classes = InputBase.classes;
TextInput.displayName = "@mantine/core/TextInput";
export { TextInput };